(function () {
  const tickerItems = Array.from(
    document.querySelectorAll<HTMLElement>('.ticker__item')
  );
  let active = 0;
  let isPlaying = true;
  let prev = tickerItems.length - 1;
  const activeClass = 'ticker__item--active';
  const leaveClass = 'ticker__item--leaving';

  const setInert = (el: HTMLElement, inert: boolean) => {
    if (inert) {
      el.setAttribute('inert', '');
    } else {
      el.removeAttribute('inert');
    }
  };

  const initTicker = () => {
    if (isPlaying) {
      if (active === tickerItems.length - 1) {
        active = 0;
        prev = tickerItems.length - 1;
      } else {
        active++;
        prev = active - 1;
      }
      tickerItems[prev].classList.remove(activeClass);
      tickerItems[prev].classList.add(leaveClass);
      setInert(tickerItems[prev], true);
      tickerItems[active].classList.remove(leaveClass);
      tickerItems[active].classList.add(activeClass);
      setInert(tickerItems[active], false);
    }
  };

  if (tickerItems.length) {
    tickerItems.forEach((item, index) => {
      setInert(item, index !== 0);
    });
    tickerItems[0].classList.add(activeClass);
  }

  if (tickerItems.length > 1) {
    setInterval(initTicker, 4000);
  }

  try {
    const tickerObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          isPlaying = true;
          return;
        }
        isPlaying = false;
      });
    });
    const tickerEl = document.querySelector('.ticker');
    if (tickerEl) {
      tickerObserver.observe(tickerEl);
    }
  } catch (e) {
    // some old browsers are incompatible with IntersectionObserver
    // In this case the ticker will not stop
    return e;
  }
})();
